<template>
  <l-cache :get-data="getEvent" :id="$route.query.id">
    <violation-detail-content slot-scope="{data}" :event="data">
      <template slot="append">
        <v-subheader>违章初步处理</v-subheader>
        <v-layout wrap>
          <v-flex xs12>
            <select-violation-rule
              :rules="$rules.required('请选择违章类型')"
              v-model="data.results[VIOLATION_ROLE.ALARM_ADMIN].type"
            ></select-violation-rule>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              label="报警中心管理员附言"
              prepend-icon="$vuetify.icons.comment"
              auto-grow
              :rows="1"
              v-model="data.results[VIOLATION_ROLE.ALARM_ADMIN].comment"></v-textarea>
          </v-flex>
        </v-layout>
      </template>
      <template slot="action">
        <v-flex layout justify-end class="pt-2">
          <v-btn :loading="revokeLoading" color="error" @click="revokeEvent(data)">撤销违章</v-btn>
          <v-btn :loading="confirmLoading" @click="preliminaryConfirm(data)" class="mx-0" color="primary">确认提交</v-btn>
        </v-flex>
      </template>
    </violation-detail-content>
  </l-cache>
</template>
<script>

import ViolationDetailContent from './violationDetailContent'
import SelectViolationRule from '../../../components/selectViolationRule'
import {VIOLATION_ROLE} from '../../../object'

export default {
  // 初步确认
  name: 'ViolationEventHandle',
  components: {SelectViolationRule, ViolationDetailContent},
  data: () => ({
    VIOLATION_ROLE,
    confirmLoading: false,
    revokeLoading: false
  }),
  methods: {
    async getEvent (key) {
      let {items, amount} = await this.$store.dispatch('violation/getEvents', {
        pagination: {},
        search: {key: 'id', value: key}
      })
      if (!amount) {
        throw Error('未找到该事件')
      }
      else {
        return items[0]
      }
    },
    async revokeEvent (event) {
      let {res, close} = await this.$L.confirm({
        title: '确认撤销',
        text: '确认撤销此违章？'
      })
      if (res) {
        try {
          this.revokeLoading = true
          await this.$store.dispatch('violation/revokeEvent', event)
          this.$L.success('撤销成功')
          this.$L.tab.close(this.$L.tab.current, false)
          this.$router.push({
            name: 'ViolationEventManagement',
            params: {refresh: true}
          })
        }
        catch (e) {
          this.$L.error(e.message)
        }
        finally {
          this.revokeLoading = false
        }
      }
      close()
    },
    async preliminaryConfirm (event) {
      if (!event.typeId) {
        this.$L.alert('error snackbar', '请选择违章类型')
        return
      }
      let {res, close} = await this.$L.confirm({
        title: '确认提交',
        text: '确认提交此违章？'
      })
      if (res) {
        try {
          this.confirmLoading = true
          await this.$store.dispatch('violation/preliminaryConfirm', event)
          this.$L.success('提交成功')
          this.$L.tab.close(this.$L.tab.current, false)
          this.$router.push({
            name: 'ViolationEventManagement',
            params: {refresh: true}
          })
        }
        catch (e) {
          this.$L.error(e.message)
        }
        finally {
          this.confirmLoading = false
        }
      }
      close()
    }
  }
}
</script>
